import { graphql } from '../gql';
import { useQuery } from '@apollo/client';

export const GET_SUBMISSION_POLICIES = graphql(`
  query getSubmissionPolicies($uuid: String) {
    submissions(filters: { nestedFilters: { entityUuid: $uuid } }) {
      pageInfo {
        totalResults
        pageSize
        hasNextPage
      }
      edges {
        cursor
        node {
          uuid
          referenceId
          type
          status
          createdAt
          brokerCommission
          policyFee
          dueDate
          policyStartDate
          policyEndDate
          policyRetroactiveDate
          productUuid
          documentLink
          quotes {
            edges {
              node {
                uuid
                limit
                retention
                policies {
                  edges {
                    node {
                      uuid
                      referenceId
                      documentLink
                      isActive
                      status
                      type
                      netPremium
                      startDate
                      endDate
                      updatedAt
                      claims {
                        edges {
                          node {
                            uuid
                            status
                            discoveryDate
                            reportedDate
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`);
export interface IUseInsuredPoliciesQueryArg {
  entityUuid?: string;
}
export function useSubmissionPoliciesQuery({
  entityUuid,
}: IUseInsuredPoliciesQueryArg) {
  const { loading, data, error } = useQuery(GET_SUBMISSION_POLICIES, {
    variables: {
      uuid: entityUuid,
    },
  });

  return {
    loading,
    error,
    data,
  };
}
